// src/pages/AdminDashboard.js
import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import CustomNavbar from '../components/Navbar/Navbar';
import Sidebar from '../components/Sidebar/Sidebar';
import AdminHomepage from './Homepage/AdminHomepage';
import UsuariosPage from './Adminpage/Usuarios/UsuariosPage';
import ResultadosPage from './Adminpage/Resultados/ResultadosPage';
import EvaluacionPage from './Adminpage/Evaluacion/EvaluacionPage';
import Archivos from './Adminpage/Archivos/Archivos';
import Politicas from './Adminpage/Politicas/Politicas';
import FormulariosPage from './Adminpage/Formularios/FormulariosPage';
import ParametrosEvaluacion from './Adminpage/Parametros/ParametrosEvaluacion ';
import '../App.css';
import './AdminDashboard.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Profile from '../auth/profile/profile';
import GestionUsuarios from './Adminpage/Usuarios/GestionUsuarios';

function AdminDashboard({ onLogout, username }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Cerrar sidebar al cambiar el tamaño de la ventana a desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768 && sidebarOpen) {
        setSidebarOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [sidebarOpen]);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  const renderCard = (Component) => (
    <div className={`card p-3 shadow-sm ${sidebarOpen && window.innerWidth >= 768 ? 'card-expanded' : 'card-collapsed'}`}>
      <Component />
    </div>
  );

  return (
    <div className="App d-flex">
      <Sidebar 
        isOpen={sidebarOpen} 
        onClose={closeSidebar}
      />
      <div className="flex-grow-1">
        <CustomNavbar 
          onLogout={onLogout} 
          username={username}
          onToggleSidebar={toggleSidebar} 
        />
        <main className={`main-content p-3 ${sidebarOpen && window.innerWidth >= 768 ? 'sidebar-open' : ''}`}>
          <Routes>
            <Route index element={renderCard(AdminHomepage)} />
            <Route path="proveedores" element={renderCard(UsuariosPage)} />
            <Route path="perfil" element={renderCard(Profile)} />
            <Route path="formularios" element={renderCard(FormulariosPage)} />
            <Route path="calificacion" element={renderCard(ResultadosPage)} />
            <Route path="archivos" element={renderCard(Archivos)} />
            <Route path="politicas" element={renderCard(Politicas)} />
            <Route path="evaluacion" element={renderCard(EvaluacionPage)} />
            <Route path="parametros-evaluacion" element={renderCard(ParametrosEvaluacion)} />
            <Route path="administrar-usuarios" element={renderCard(GestionUsuarios)} />
            <Route path="*" element={renderCard(AdminHomepage)} />
          </Routes>
        </main>
      </div>
    </div>
  );
}

export default AdminDashboard;